<template>
  <!-- begin:: Header -->
  <div id="kt_header" ref="kt_header" class="header" v-bind:class="headerClasses">
    <div class="container-fluid d-flex align-items-center justify-content-between">
      <!-- begin:: Header Menu -->
      <div class="header-menu-wrapper header-menu-wrapper-left" ref="kt_header_menu_wrapper">
        <div v-if="headerMenuEnabled" id="kt_header_menu" ref="kt_header_menu" class="header-menu header-menu-mobile"
          v-bind:class="headerMenuClasses">
          <ul class="menu-nav">
            <li class=" menu-item-submenu menu-item-rel menu-item-active menu-item-open-dropdown">
              <h5 style="color:white" class="mt-2">{{ currentUser.c.name }}</h5>
            </li>
          </ul>
        </div>
      </div>
      <!-- end:: Header Menu -->
      <div class="d-flex align-items-center">
        <Impersonator v-if="currentUser.i" />
        <KTTopbar></KTTopbar>
      </div>
    </div>
  </div>
  <!-- end:: Header -->
</template>

<script>
import { mapGetters } from "vuex";
import KTTopbar from "@/includes/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import KTLayoutHeaderMenu from "@/assets/js/layout/base/header-menu.js";
import Impersonator from "@/includes/header/Impersonator.vue";

export default {
  name: "KTHeader",
  components: {
    KTTopbar,
    Impersonator
  },
  mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init("kt_header", "kt_header_mobile");

    // Init Header Menu
    KTLayoutHeaderMenu.init(
      this.$refs["kt_header_menu"],
      this.$refs["kt_header_menu_wrapper"]
    );
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses", "currentUser"]),

    /**
     * Check if the header menu is enabled
     * @returns {boolean}
     */
    headerMenuEnabled() {
      return !!this.layoutConfig("header.menu.self.display");
    },

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Get extra classes for header menu based on the options
     * @returns {null|*}
     */
    headerMenuClasses() {
      const classes = this.getClasses("header_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    }
  }
};
</script>
<style scoped lang="scss">
#kt_header {
  background: #0084d3 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 2px 12px rgba(56, 154, 212, 0.3) !important;

  &.kt_header_toggle {
    margin-left: 264px !important;
  }

  margin-left: 60px;

  h5 {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: rgba(255, 255, 255, 0.9) !important;
  }
}
</style>
